module.exports = __webpack_public_path__ + "134c52e79d5aa151cc5bee0482e0ec24.svg";